import { render, staticRenderFns } from "./employeeMain.vue?vue&type=template&id=323a0f12&scoped=true"
import script from "./employeeMain.vue?vue&type=script&lang=js"
export * from "./employeeMain.vue?vue&type=script&lang=js"
import style0 from "./employeeMain.vue?vue&type=style&index=0&id=323a0f12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323a0f12",
  null
  
)

export default component.exports